'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadFacets = loadFacets;

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FACETS_LOAD = 'ms/facets/facets_load';
var FACETS_LOAD_SUCCESS = 'ms/facets/facets_load_success';
var FACETS_LOAD_FAIL = 'ms/facets/facets_load_fail';

var initialState = {
  facets: null,
  filters: null,
  categoriesCache: [],
  subCategoriesCache: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case FACETS_LOAD:
      return (0, _extends3.default)({}, state, {
        loadingFacets: true,
        oldFilters: state.filters,
        filters: action.meta.filters
      });

    case FACETS_LOAD_SUCCESS:
      var filters = action.meta.filters;
      var facets = transformFacets(action.result.facets);
      var oldFilters = state.oldFilters;

      var categoriesCache = state.categoriesCache;
      var subCategoriesCache = state.subCategoriesCache;
      var nextCategoriesCache = buildCache(categoriesCache, {
        type: filters.type
      }, facets.category || []);
      var nextSubCategoriesCache = action.meta.willLoadSubcategories ? [] : buildCache(subCategoriesCache, {
        type: filters.type,
        category: filters.category
      }, facets.subCategory || []);

      if (oldFilters) {
        // not loading for the first time
        return (0, _extends3.default)({}, state, {
          loadingFacets: false,
          filters: filters,
          categoriesCache: nextCategoriesCache,
          subCategoriesCache: nextSubCategoriesCache,
          facets: (0, _extends3.default)({}, state.facets, {
            category: pickCache(nextCategoriesCache, { type: filters.type }),
            subCategory: pickCache(nextSubCategoriesCache, {
              type: filters.type,
              category: filters.category
            })
          })
        });
      }

      return (0, _extends3.default)({}, state, {
        categoriesCache: nextCategoriesCache,
        subCategoriesCache: nextSubCategoriesCache,
        loadingFacets: false,
        filters: filters,
        facets: facets
      });

    default:
      return state;
  }
};

function loadFacets(_ref) {
  var type = _ref.type,
      category = _ref.category;

  return function (dispatch, getState) {
    var currentFilters = getState().facets.filters;

    if (_ramda2.default.equals((0, _utils.cleanObj)({ type: type, category: category, facetsOnly: true }), (0, _utils.cleanObj)(currentFilters))) {
      return null;
    }

    var callDispatch = function callDispatch(filters, willLoadSubcategories) {
      return dispatch({
        types: [FACETS_LOAD, FACETS_LOAD_SUCCESS, FACETS_LOAD_FAIL],
        meta: { filters: filters, willLoadSubcategories: willLoadSubcategories },
        promise: function promise(client) {
          return client.get('v1/assets?' + _qs2.default.stringify((0, _utils.cleanObj)(filters)));
        }
      });
    };

    var called = false;

    return _bluebird2.default.try(function () {
      if (currentFilters === null) {
        called = true;
        return callDispatch({ facetsOnly: true });
      }
    }).then(function () {
      if (type) {
        called = true;
        return callDispatch({ type: type, facetsOnly: true }, !!category);
      }
    }).then(function () {
      if (category) {
        called = true;
        return callDispatch({ type: type, category: category, facetsOnly: true });
      }
    }).then(function () {
      if (!called) {
        return dispatch({
          type: FACETS_LOAD_SUCCESS,
          meta: { filters: { type: type, facetsOnly: true } },
          result: { facets: [] }
        });
      }
    });
  };
}

// Helper functions

var capitalize = _ramda2.default.converge(_ramda2.default.concat, [_ramda2.default.compose(_ramda2.default.toUpper, _ramda2.default.head), _ramda2.default.tail]);
var hasNonNullField = _ramda2.default.compose(_ramda2.default.any(_ramda2.default.complement(_ramda2.default.isNil)), _ramda2.default.values);
var transformFacets = _ramda2.default.mapObjIndexed(function (facet) {
  return _ramda2.default.compose(_ramda2.default.map(function (slug) {
    return { label: capitalize(slug), slug: slug };
  }), _ramda2.default.keys)(facet);
});

var pickCache = function pickCache(cache, filters) {
  return _ramda2.default.filter(_ramda2.default.whereEq(filters), cache);
};
var buildCache = function buildCache(cache, filters, values) {
  return _ramda2.default.ifElse(_ramda2.default.compose(_ramda2.default.lt(0), _ramda2.default.length, function () {
    return pickCache(cache, filters);
  }), _ramda2.default.always(cache), _ramda2.default.compose(_ramda2.default.uniqWith(_ramda2.default.equals), _ramda2.default.concat(cache), _ramda2.default.map(_ramda2.default.merge(filters))))(values);
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/facets.js
// module id = 1005
// module chunks = 0